export const commonConstants = {
    ACTUALIZATION_UPLOAD_NEW_ACTUALIZATION: 'upload_new_actualization',
    ACTUALIZATION_UPLOAD_ACTUALIZATION_UPDATE: 'upload_actualization_update',
    ACTUALIZATION_SETUP_ACTUALIZATION: 'setup_actualization'
}